module.exports = __webpack_public_path__ + "img/logo.376a50ae.svg";